import React from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import {
    CountryGetLocalization,
    FieldGetLocalization,
    SingleGetLocalization,
    Organization,
} from '../../../services/interfaces/schedule.interface/schedule.getlocalizationdata.interface'
import { request_get_localization_data } from '../../../services/schedule.services'
import { schedulesServices } from '../../../../database/schedules.database'
import { validateConnectionNetwork } from '../../../utils/functions.utils'

export const COUNTRY_ID_ARG = '6463ddc820bc52c864a6cab4'
export const COUNTRY_ID_MEX = '637e3c916d22752787878f41'

export const useCreateStore = () => {
    const getAndSaveDataGeolocalization = async () => {
        try {
            const hasConnection = await validateConnectionNetwork()

            if (!hasConnection) {
                console.error('getAndSaveDataGeolocalization - No hay conexión a internet')
                return
            }

            const data = await getLocalization()

            await saveDateInDb(data)
        } catch (error) {
            console.error('getAndSaveDataGeolocalization => ', error)
        }
    }

    const getCountryId = (): string => {
        // logica para devolver el country id segun el user
        let countryId = COUNTRY_ID_MEX
        return countryId
    }
    const getLocalization = async (): Promise<SingleGetLocalization> => {
        //* verificar si existe en la db local, sino hacer la request
        let dataRequestGeo = null
        const session = await fetchAuthSession()
        const authToken = session.tokens?.accessToken?.toString() || ""

        const data = {
            authToken,
            country_id: getCountryId(),
        }
        const response = await request_get_localization_data(data)

        if (response && response.status == 1) {
            dataRequestGeo = response.single
        }
        return dataRequestGeo
    }

    const saveDateInDb = async (data: SingleGetLocalization) => {
        try {
            console.log('saveDateInDb - data to save:', data)
            if (!data || !data.fields || !data.fields_organization || !data.country || !data.organizations) {
                console.error('saveDateInDb - Datos incompletos', data)
                return
            }
            await saveFields(data.fields)
            await saveFields(data.fields_organization, true)
            await saveCountry(data.country)
            await saveOrganizations(data.organizations)
        } catch (error) {
            console.error('saveDateInDb => ', error)
        }
    }

    const saveFields = async (fields: FieldGetLocalization[], orgnanization = false) => {
        try {
            if (fields.length === 0) {
                console.warn('saveFields - No hay campos para guardar')
                return
            }
            if (orgnanization) {
                await schedulesServices.saveFieldsOrganizationCreatePos(fields)
            } else {
                await schedulesServices.saveFieldsCreatePos(fields)
            }
        } catch (error) {
            console.error('saveFields error => ', error)
        }
    }

    const saveOrganizations = async (organizations: Organization[]) => {
        try {
            await schedulesServices.addOrganizaciones(organizations)
        } catch (error) {
            console.error('saveOrganizations error => ', error)
        }
    }

    const saveCountry = async (country: CountryGetLocalization) => {
        try {
            await schedulesServices.saveCountryData(country)
        } catch (error) {
            console.error('saveCountry error => ', error)
        }
    }

    return {
        getAndSaveDataGeolocalization,
    }
}
